// extracted by mini-css-extract-plugin
module.exports = {"container":"ToPause_container__z8_kH","grouped":"ToPause_grouped__CX4RD"};